import { DeviceType } from 'config/types/common.type';
import { useEffect, useState } from 'react';

const getDeviceType = (width: number): DeviceType => {
  if (width <= 767) {
    return 'mobile';
  } else if (width >= 768 && width <= 1024) {
    return 'tablet';
  } else {
    return 'desktop';
  }
};

export const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>(getDeviceType(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType(window.innerWidth));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return deviceType;
};
